import React, { useState, useEffect } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './CookieBanner.module.css';
import { replaceUnderscoresWithHyphens } from '../../util/string';
import { pushEvent } from '../../analytics/dataLayer';
import { getStoredConsent, storeConsent, updateGtagConsent } from '../../analytics/consent';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const storedConsent = getStoredConsent();
    if (!storedConsent) {
      setIsVisible(true);
      if (typeof _paq !== 'undefined') {
        _paq.push(['trackEvent', 'Cookies', 'CookieBannerView']);
      }
    } else {
      // Consent Mode v2 state is restored synchronously by the inline script in
      // util/includeScripts.js before gtm.js loads. This custom event is kept
      // only for backward compat with container triggers based on it.
      pushEvent('cookie_consent_update', { consent_status: storedConsent });
    }
  }, []);

  const handleAcceptAll = () => {
    storeConsent(true);
    setIsVisible(false);
    updateGtagConsent(true);
    if (typeof _paq !== 'undefined') {
      _paq.push(['rememberCookieConsentGiven']);
      _paq.push(['trackEvent', 'Cookies', 'CookieBannerAccept']);
    }
    pushEvent('cookie_consent_update', { consent_status: 'granted' });
  };

  const handleRejectAll = () => {
    storeConsent(false);
    setIsVisible(false);
    updateGtagConsent(false);
    if (typeof _paq !== 'undefined') {
      // Withdraw a previously remembered Matomo consent, if any.
      _paq.push(['forgetCookieConsentGiven']);
      _paq.push(['trackEvent', 'Cookies', 'CookieBannerReject']);
    }
    pushEvent('cookie_consent_update', { consent_status: 'denied' });
  };

  if (!isVisible) {
    return null;
  }

  const brandNameOriginal = process.env.REACT_APP_BRAND_NAME;
  const brandName = replaceUnderscoresWithHyphens(brandNameOriginal);
  const policyUrl = `/p/privacy-policy-${brandName}`;

  return (
    <div className={css.cookieBanner}>
      <div className={css.content}>
        <h2 className={css.title}>
          <FormattedMessage id="CookieBanner.title" />
        </h2>
        <p className={css.description}>
          <FormattedMessage id="CookieBanner.description" />{' '}
          <a href={policyUrl} className={css.link}>
            <FormattedMessage id="CookieBanner.policyLink" />
          </a>
        </p>
      </div>
      <div className={css.buttons}>
        <button onClick={handleRejectAll} className={css.rejectButton}>
          <FormattedMessage id="CookieBanner.rejectButton" />
        </button>
        <button onClick={handleAcceptAll} className={css.acceptButton}>
          <FormattedMessage id="CookieBanner.acceptButton" />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
